import { render, staticRenderFns } from "./ViewAllInterviewers.vue?vue&type=template&id=797dff7a&scoped=true"
import script from "./ViewAllInterviewers.vue?vue&type=script&lang=ts"
export * from "./ViewAllInterviewers.vue?vue&type=script&lang=ts"
import style0 from "./ViewAllInterviewers.vue?vue&type=style&index=0&id=797dff7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797dff7a",
  null
  
)

export default component.exports